<template>
    <div class="batchCard table-hook fadeInRight">
        <div class="title-box">
            <span class="m-title">批量导入</span>
            <el-form
                inline
                class="hook right themed-form search-form"
                style="height: 40px; line-height: 40px"
            >
                <el-form-item label="导入类型:">
                    <el-select v-model="type" placeholder="全部" filterable>
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            label="过期时间"
                            value="1"
                            v-if="dicOperte.one == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="窜卡复机"
                            value="2"
                            v-if="dicOperte.two == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="设置阀值"
                            value="4"
                            v-if="dicOperte.four == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="删除卡"
                            value="5"
                            v-if="dicOperte.five == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="窜卡"
                            value="6"
                            v-if="dicOperte.six == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="变更套餐"
                            value="7"
                            v-if="
                                dicOperte.seven == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                        ></el-option>
                        <el-option
                            label="机卡重绑"
                            value="9"
                            v-if="dicOperte.nine == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="网卡回收"
                            value="10"
                            v-if="
                                dicOperte.ten == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                        ></el-option>
                        <el-option
                            label="网卡注销"
                            value="11"
                            v-if="dicOperte.eleven == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="不续费充值"
                            value="12"
                            v-if="dicOperte.twelve == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="增减流量"
                            value="13"
                            v-if="dicOperte.thirteen == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="导入IMEI库"
                            value="16"
                            v-if="dicOperte.sixteen == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="修改类型"
                            value="17"
                            v-if="
                                dicOperte.seventeen == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="设置过期时间"
                            value="18"
                            v-if="dicOperte.eighteen == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="计费组达量闸值"
                            value="19"
                            v-if="dicOperte.nineteen == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="取消单独断网"
                            value="20"
                            v-if="dicOperte.twenty == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="网卡备注"
                            value="21"
                            v-if="
                                dicOperte.twentyOne == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="虚拟卡数据清零"
                            value="22"
                            v-if="
                                dicOperte.twentytwo == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                        ></el-option>
                        <el-option
                            label="停复机"
                            value="23"
                            v-if="
                                dicOperte.twentythree == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                        ></el-option>
                        <el-option
                            label="停用虚拟卡绑定"
                            value="24"
                            v-if="
                                dicOperte.twentyfour == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="运营商"
                            value="25"
                            v-if="
                                dicOperte.twentyfive == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="短号"
                            value="26"
                            v-if="
                                dicOperte.twentysix == '1' && currentRole == 0
                            "
                        ></el-option>
                        <!-- <el-option label="接入号" value="27"></el-option>
                     <el-option label="iccid修改" value="28"></el-option> -->
                        <el-option
                            label="沉默期激活"
                            value="30"
                            v-if="dicOperte.thirty == '1' && currentRole == 0"
                        ></el-option>
                        <el-option
                            label="沉默期修改"
                            value="31"
                            v-if="
                                dicOperte.thirtyone == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="变更充值模式"
                            value="32"
                            v-if="
                                dicOperte.thirtytwo == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="提前生效套餐"
                            value="33"
                            v-if="
                                dicOperte.thirtythree == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="修改流量类型"
                            value="34"
                            v-if="
                                dicOperte.thirtyfour == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="修改归属省份"
                            value="35"
                            v-if="
                                dicOperte.thirtyfive == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="修改切卡策略"
                            value="36"
                            v-if="
                                dicOperte.thirtysix == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="更新卡信息"
                            value="37"
                            v-if="
                                dicOperte.thirtyseven == '1' &&
                                currentRole == 0 &&
                                showBatchUpdateCard
                            "
                        ></el-option>
                        <el-option
                            label="临时卡号"
                            value="46"
                            v-if="
                                dicOperte.fortysix == '1' &&
                                currentRole == 0 &&
                                TEMP_CARD == 1
                            "
                        ></el-option>
                        <el-option
                            label="删除临时卡号"
                            value="47"
                            v-if="
                                dicOperte.fortyseven == '1' &&
                                currentRole == 0 &&
                                TEMP_CARD == 1
                            "
                        ></el-option>
                        <el-option
                            label="写号实名限制"
                            value="52"
                            v-if="
                                dicOperte.fiftytwo == '1' &&
                                currentRole == 0 &&
                                REAL_NAME_LIMIT == 1 &&
                                false
                            "
                        ></el-option>
                        <el-option
                            label="修改认证信息"
                            value="53"
                            v-if="
                                dicOperte.fiftythree == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="刷新流量"
                            value="58"
                            v-if="
                                dicOperte.fiftyeight == '1' && currentRole == 0
                            "
                        ></el-option>
                        <el-option
                            label="MAC导入"
                            value="59"
                            v-if="
                                dicOperte.fiftynine == '1' && currentRole == 0
                            "
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="searchTable"
                        >搜索查询</el-button
                    >
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="themed-button"
                        @click="importRecord"
                        >批量导入</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="导入总数"
                    prop="importTotal"
                ></el-table-column>
                <el-table-column
                    label="成功数"
                    prop="importSuccess"
                ></el-table-column>
                <el-table-column
                    label="失败数"
                    prop="importFail"
                ></el-table-column>
                <el-table-column label="导入类型" prop="type">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type === 1">过期时间</span>
                        <span v-if="scope.row.type === 2">窜卡复机</span>
                        <span v-if="scope.row.type === 4">设置阀值</span>
                        <span v-if="scope.row.type === 5">删除卡</span>
                        <span v-if="scope.row.type === 6">窜卡</span>
                        <span v-if="scope.row.type === 7">变更套餐</span>
                        <span v-if="scope.row.type === 9">机卡重绑</span>
                        <span v-if="scope.row.type === 10">网卡回收</span>
                        <span v-if="scope.row.type === 11">网卡注销</span>
                        <span v-if="scope.row.type === 12">不续费充值</span>
                        <span v-if="scope.row.type === 13">增减流量</span>
                        <span v-if="scope.row.type === 16">导入IMEI库</span>
                        <span v-if="scope.row.type === 17">修改类型</span>
                        <span v-if="scope.row.type === 18">设置过期时间</span>
                        <span v-if="scope.row.type === 19">计费组达量闸值</span>
                        <span v-if="scope.row.type === 20">取消单独断网</span>
                        <span v-if="scope.row.type === 21">网卡备注</span>
                        <span v-if="scope.row.type === 22">虚拟卡数据清零</span>
                        <span v-if="scope.row.type === 23">停复机</span>
                        <span v-if="scope.row.type === 24">停用虚拟卡绑定</span>
                        <span v-if="scope.row.type === 25">运营商</span>
                        <span v-if="scope.row.type === 26">短号</span>
                        <!-- <span v-if="scope.row.type===27">接入号</span>
                    <span v-if="scope.row.type===28">iccid修改</span> -->
                        <span v-if="scope.row.type === 30">沉默期激活</span>
                        <span v-if="scope.row.type === 31">沉默期修改</span>
                        <span v-if="scope.row.type === 32">变更充值模式</span>
                        <span v-if="scope.row.type === 33">提前生效套餐</span>
                        <span v-if="scope.row.type === 34">修改流量类型</span>
                        <span v-if="scope.row.type === 35">修改归属省份</span>
                        <span v-if="scope.row.type === 36">修改切卡策略</span>
                        <span v-if="scope.row.type === 37">更新卡信息</span>
                        <span v-if="scope.row.type === 46">临时卡号</span>
                        <span v-if="scope.row.type === 47">删除临时卡号</span>
                        <span v-if="scope.row.type === 52">写号实名限制</span>
                        <span v-if="scope.row.type === 53">修改认证信息</span>
                        <span v-if="scope.row.type === 58">刷新流量</span>
                        <span v-if="scope.row.type === 59">MAC导入</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作人"
                    prop="operatorName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="操作时间"
                    prop="createDatetime"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            class="themed-button"
                            @click="loadFail(scope.row.id)"
                            >查看详情</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 50, 100, 1000]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>

        <el-dialog title="批量导入" :visible.sync="dialogBox">
            <el-form
                label-position="right"
                label-width="120px"
                :model="form"
                ref="form"
                v-loading="dialogLoading"
                :rules="rules"
            >
                <el-form-item label="导入类型:" prop="type" required>
                    <el-radio-group v-model="form.type" @change="typeChange">
                        <el-radio
                            :label="1"
                            v-if="dicOperte.one == '1' && currentRole == 0"
                            >过期时间</el-radio
                        >
                        <el-radio
                            :label="2"
                            v-if="dicOperte.two == '1' && currentRole == 0"
                            >窜卡复机</el-radio
                        >
                        <el-radio
                            :label="4"
                            v-if="dicOperte.four == '1' && currentRole == 0"
                            >达量阀值</el-radio
                        >
                        <el-radio
                            :label="5"
                            v-if="dicOperte.five == '1' && currentRole == 0"
                            >删除卡</el-radio
                        >
                        <el-radio
                            :label="6"
                            v-if="dicOperte.six == '1' && currentRole == 0"
                            >窜卡</el-radio
                        >
                        <el-radio
                            :label="7"
                            @change="handleTypeChange"
                            v-if="
                                dicOperte.seven == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                            >变更套餐</el-radio
                        >
                        <el-radio
                            :label="9"
                            v-if="dicOperte.nine == '1' && currentRole == 0"
                            >机卡重绑</el-radio
                        >
                        <el-radio
                            :label="10"
                            v-if="
                                dicOperte.ten == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                            >网卡回收</el-radio
                        >
                        <el-radio
                            :label="11"
                            v-if="dicOperte.eleven == '1' && currentRole == 0"
                            >网卡注销</el-radio
                        >
                        <el-radio
                            :label="12"
                            v-if="dicOperte.twelve == '1' && currentRole == 0"
                            >不续费充值</el-radio
                        >
                        <el-radio
                            :label="13"
                            v-if="dicOperte.thirteen == '1' && currentRole == 0"
                            >增减流量</el-radio
                        >
                        <el-radio
                            :label="16"
                            @change="_accountList"
                            v-if="dicOperte.sixteen == '1' && currentRole == 0"
                            >导入IMEI库</el-radio
                        >
                        <el-radio
                            :label="17"
                            v-if="
                                dicOperte.seventeen == '1' && currentRole == 0
                            "
                            >修改类型</el-radio
                        >
                        <el-radio
                            :label="18"
                            v-if="dicOperte.eighteen == '1' && currentRole == 0"
                            >设置过期时间</el-radio
                        >
                        <el-radio
                            :label="19"
                            v-if="dicOperte.nineteen == '1' && currentRole == 0"
                            >计费组达量闸值</el-radio
                        >
                        <el-radio
                            :label="20"
                            v-if="dicOperte.twenty == '1' && currentRole == 0"
                            >取消单独断网</el-radio
                        >
                        <el-radio
                            :label="21"
                            v-if="
                                dicOperte.twentyOne == '1' && currentRole == 0
                            "
                            >网卡备注</el-radio
                        >
                        <el-radio
                            :label="22"
                            v-if="
                                dicOperte.twentytwo == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                            >虚拟卡数据清零</el-radio
                        >
                        <el-radio
                            :label="23"
                            v-if="
                                dicOperte.twentythree == '1' &&
                                (currentRole == 0 ||
                                    (currentRole == 4 && agentTree == 1))
                            "
                            >停复机</el-radio
                        >
                        <el-radio
                            :label="24"
                            v-if="
                                dicOperte.twentyfour == '1' && currentRole == 0
                            "
                            >停用虚拟卡绑定</el-radio
                        >
                        <el-radio
                            :label="25"
                            @change="_accountList"
                            v-if="
                                dicOperte.twentyfive == '1' && currentRole == 0
                            "
                            >运营商</el-radio
                        >
                        <el-radio
                            :label="26"
                            v-if="
                                dicOperte.twentysix == '1' && currentRole == 0
                            "
                            >短号</el-radio
                        >
                        <!-- <el-radio :label="27">接入号</el-radio>
                    <el-radio :label="28">iccid修改</el-radio> -->
                        <el-radio
                            :label="30"
                            v-if="dicOperte.thirty == '1' && currentRole == 0"
                            >沉默期激活</el-radio
                        >
                        <el-radio
                            :label="31"
                            v-if="
                                dicOperte.thirtyone == '1' && currentRole == 0
                            "
                            >沉默期修改</el-radio
                        >
                        <el-radio
                            :label="32"
                            v-if="
                                dicOperte.thirtytwo == '1' && currentRole == 0
                            "
                            >变更充值模式</el-radio
                        >
                        <el-radio
                            :label="33"
                            v-if="
                                dicOperte.thirtythree == '1' && currentRole == 0
                            "
                            >提前生效套餐</el-radio
                        >
                        <el-radio
                            :label="34"
                            v-if="
                                dicOperte.thirtyfour == '1' && currentRole == 0
                            "
                            >修改流量类型</el-radio
                        >
                        <el-radio
                            :label="35"
                            v-if="
                                dicOperte.thirtyfive == '1' && currentRole == 0
                            "
                            >修改归属省份</el-radio
                        >
                        <el-radio
                            :label="36"
                            v-if="
                                dicOperte.thirtysix == '1' && currentRole == 0
                            "
                            >修改切卡策略</el-radio
                        >

                        <el-radio
                            :label="37"
                            v-if="
                                dicOperte.thirtyseven == '1' &&
                                currentRole == 0 &&
                                showBatchUpdateCard
                            "
                            >更新卡信息</el-radio
                        >
                        <el-radio
                            :label="46"
                            v-if="
                                dicOperte.fortysix == '1' &&
                                currentRole == 0 &&
                                TEMP_CARD == 1
                            "
                            >临时卡号</el-radio
                        >
                        <el-radio
                            :label="47"
                            v-if="
                                dicOperte.fortyseven == '1' &&
                                currentRole == 0 &&
                                TEMP_CARD == 1
                            "
                            >删除临时卡号</el-radio
                        >
                        <el-radio
                            :label="52"
                            v-if="
                                dicOperte.fiftytwo == '1' &&
                                currentRole == 0 &&
                                REAL_NAME_LIMIT == 1 &&
                                false
                            "
                            >写号实名限制</el-radio
                        >
                        <el-radio
                            :label="53"
                            v-if="
                                dicOperte.fiftythree == '1' && currentRole == 0
                            "
                            >修改认证信息</el-radio
                        >
                        <el-radio
                            :label="58"
                            v-if="
                                dicOperte.fiftyeight == '1' && currentRole == 0
                            "
                            >刷新流量</el-radio
                        >
                        <el-radio
                            :label="59"
                            v-if="
                                dicOperte.fiftynine == '1' && currentRole == 0
                            "
                            >MAC导入</el-radio
                        >
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择excel文件:" :required="isRequired">
                    <input class="file-input" type="file" ref="file" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item
                    :label="manualInputTitle"
                    v-if="
                        form.type === 10 ||
                        form.type === 25 ||
                        form.type === 26 ||
                        form.type === 32 ||
                        form.type === 33 ||
                        form.type === 7 ||
                        form.type === 34 ||
                        form.type === 35 ||
                        form.type === 36 ||
                        form.type === 37 ||
                        form.type === 46 ||
                        form.type === 47 ||
                        form.type === 52 ||
                        form.type === 53 ||
                        form.type === 58 ||
                        form.type === 59
                    "
                >
                    <el-input
                        v-model="form.iccids"
                        type="textarea"
                        :placeholder="placeholderText"
                    ></el-input>
                </el-form-item>

                <el-form-item
                    label="运营商账号:"
                    required
                    prop="account"
                    v-if="form.type === 16 || form.type === 25"
                >
                    <el-select
                        v-model="form.account"
                        filterable
                        clearable
                        placeholder="请选择运营商"
                        @change="changeGetMeal"
                    >
                        <el-option
                            v-for="(item, index) in imeiAccountList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    <!-- <search-select :optionsMetaAll="imeiAccountList" v-model="form.account" @change="changeGetMeal"></search-select> -->
                </el-form-item>
                <el-form-item
                    label="套餐:"
                    prop="setMealId"
                    v-if="form.type === 25"
                >
                    <el-select
                        v-model="form.setMealId"
                        :filterable="packageLists.length > 0"
                        placeholder="请选择套餐"
                        clearable
                        @visible-change="secondClick"
                    >
                        <el-option
                            v-for="(item, index) in packageLists"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="导入方式:"
                    required
                    prop="imeiIsDelete"
                    v-if="form.type === 16"
                >
                    <el-select v-model="form.imeiIsDelete" placeholder="请选择">
                        <el-option label="导入" value="false"></el-option>
                        <el-option label="删除" value="true"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 套餐系列选择（仅新UI显示） -->
                <el-form-item
                    label="套餐系列:"
                    v-if="form.type === 7 && SHOW_MEAL_SERIES == 1"
                >
                    <el-select
                        v-model="form.seriesId"
                        @change="handleSeriesChange"
                        placeholder="请选择套餐系列"
                        clearable
                        filterable
                    >
                        <el-option
                            v-for="item in seriesOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="新套餐:"
                    required
                    prop="newMeals"
                    v-if="form.type === 7"
                >
                    <el-select
                        v-model="form.newMeals"
                        placeholder="请选择"
                        filterable
                    >
                        <el-option
                            v-for="item in newMealsList"
                            :key="item.index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="操作类型:"
                    required
                    prop="action"
                    v-if="form.type === 4"
                >
                    <el-select v-model="form.action" placeholder="请选择">
                        <el-option label="新增达量断网" value="1"></el-option>
                        <el-option label="修改达量断网" value="2"></el-option>
                        <el-option label="取消达量断网" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="断网阈值:"
                    required
                    prop="quota"
                    v-if="form.type === 4"
                >
                    <el-input v-model="form.quota"></el-input>
                    <span>（只能输入数字，单位：M，-1表示无限制）</span>
                </el-form-item>
                <el-form-item
                    label="单卡闸值达量断网:"
                    required
                    prop="flowStop"
                    v-if="form.type === 19"
                >
                    <el-input v-model="form.flowStop"></el-input>
                    <span>（只能输入数字，单位：M）</span>
                </el-form-item>
                <el-form-item
                    label="断网类型:"
                    required
                    prop="daliangType"
                    v-if="form.type === 4"
                >
                    <el-select v-model="form.daliangType" placeholder="请选择">
                        <el-option label="用户总使用量" value="1"></el-option>
                        <el-option
                            label="超出套餐外使用量"
                            value="2"
                        ></el-option>
                    </el-select>
                    <p>（用户级，阈值次月恢复；套餐级，阈值次周期恢复）</p>
                </el-form-item>
                <el-form-item
                    label="更改方式:"
                    required
                    prop="expiredType"
                    v-if="form.type === 1"
                >
                    <el-radio-group v-model="form.expiredType">
                        <el-radio :label="1"
                            >单独变更（单卡多套餐分别增减过期时间）</el-radio
                        >
                        <el-radio :label="2"
                            >统一变更（单卡所有套餐统一变更）</el-radio
                        >
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="业务类型:"
                    required
                    prop="toType"
                    v-if="form.type === 17"
                >
                    <el-select v-model="form.toType" placeholder="请选择">
                        <el-option label="请选择" value=""></el-option>
                        <el-option
                            v-for="(item, index) in w_TOTYPE_"
                            :key="index"
                            :label="item.groupName"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="销售类型:"
                    required
                    prop="saleType"
                    v-if="form.type === 17"
                >
                    <el-select v-model="form.saleType" placeholder="请选择">
                        <el-option label="请选择" value=""></el-option>
                        <el-option label="线上" value="1"></el-option>
                        <el-option
                            label="线下"
                            value="2"
                            v-if="isCaptal != '1'"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="合作类型:"
                    required
                    prop="coType"
                    v-if="form.type === 17"
                >
                    <el-select v-model="form.coType" placeholder="请选择">
                        <el-option label="请选择" value=""></el-option>
                        <el-option
                            v-for="(item, index) in w_COTYPE_"
                            :key="index"
                            :label="item.groupName"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="产品类型:"
                    required
                    prop="productType"
                    v-if="form.type === 17"
                >
                    <el-select v-model="form.productType" placeholder="请选择">
                        <el-option label="请选择" value=""></el-option>
                        <el-option
                            v-for="(item, index) in w_PRODUCT_"
                            :key="index"
                            :label="item.groupName"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="有效期:"
                    required
                    prop="expireTime"
                    v-if="form.type === 18"
                >
                    <el-date-picker
                        v-model="form.expireTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item
                    label="更改方式:"
                    required
                    prop="status"
                    v-if="form.type === 23"
                >
                    <el-radio-group v-model="form.status">
                        <el-radio :label="0">停机</el-radio>
                        <el-radio :label="1">复机</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item
                    label="沉默期时间:"
                    required
                    prop="silentExpireTime"
                    v-if="form.type === 31"
                >
                    <el-date-picker
                        v-model="form.silentExpireTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item
                    label="充值类型:"
                    required
                    prop="rechargeType"
                    v-if="form.type === 32"
                >
                    <el-select v-model="form.rechargeType" placeholder="请选择">
                        <el-option label="请选择" value=""></el-option>
                        <el-option label="普通类型" value="1"></el-option>
                        <el-option
                            label="预存话费类型"
                            value="2"
                            v-if="parseInt(isGuangyao)"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="流量类型:"
                    required
                    prop="flowType"
                    v-if="form.type === 34"
                >
                    <el-select v-model="form.flowType" placeholder="请选择">
                        <!-- <el-option label="默认" value="0"></el-option> -->
                        <el-option label="本省流量" value="1"></el-option>
                        <el-option
                            label="全国流量"
                            value="2"
                            v-if="parseInt(isGuangyao)"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                    label="归属省份:"
                    required
                    prop="province"
                    v-if="form.type === 35"
                >
                    <el-select v-model="form.province" placeholder="请选择">
                        <!-- <el-option label="默认" value="0"></el-option> -->
                        <el-option label="北京市" value="110000"></el-option>
                        <el-option label="天津市" value="120000"></el-option>
                        <el-option label="河北省" value="130000"></el-option>
                        <el-option label="山西省" value="140000"></el-option>
                        <el-option
                            label="内蒙古自治区"
                            value="150000"
                        ></el-option>
                        <el-option label="辽宁省" value="210000"></el-option>
                        <el-option label="吉林省" value="220000"></el-option>
                        <el-option label="黑龙江省" value="230000"></el-option>
                        <el-option label="上海市" value="310000"></el-option>
                        <el-option label="江苏省" value="320000"></el-option>
                        <el-option label="浙江省" value="330000"></el-option>
                        <el-option label="安徽省" value="340000"></el-option>
                        <el-option label="福建省" value="350000"></el-option>
                        <el-option label="江西省" value="360000"></el-option>
                        <el-option label="山东省" value="370000"></el-option>
                        <el-option label="河南省" value="410000"></el-option>
                        <el-option label="湖北省" value="420000"></el-option>
                        <el-option label="湖南省" value="430000"></el-option>
                        <el-option label="广东省" value="440000"></el-option>
                        <el-option
                            label="广西壮族自治区"
                            value="450000"
                        ></el-option>
                        <el-option label="海南省" value="460000"></el-option>
                        <el-option label="重庆市" value="500000"></el-option>
                        <el-option label="四川省" value="510000"></el-option>
                        <el-option label="贵州省" value="520000"></el-option>
                        <el-option label="云南省" value="530000"></el-option>
                        <el-option
                            label="西藏自治区"
                            value="540000"
                        ></el-option>
                        <el-option label="陕西省" value="610000"></el-option>
                        <el-option label="甘肃省" value="620000"></el-option>
                        <el-option label="青海省" value="630000"></el-option>
                        <el-option
                            label="宁夏回族自治区"
                            value="640000"
                        ></el-option>
                        <el-option
                            label="新疆维吾尔自治区"
                            value="650000"
                        ></el-option>
                        <el-option label="台湾省" value="710000"></el-option>
                        <el-option
                            label="香港特别行政区"
                            value="810000"
                        ></el-option>
                        <el-option
                            label="澳门特别行政区"
                            value="820000"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="操作类型:"
                    required
                    prop="operationType"
                    v-if="form.type === 37"
                >
                    <el-select
                        v-model="form.operationType"
                        placeholder="请选择"
                    >
                        <el-option label="更新卡信息" value="1"></el-option>
                        <el-option label="恢复卡信息" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="操作类型:"
                    required
                    prop="writeCardLimitType"
                    v-if="form.type === 52"
                >
                    <el-select
                        v-model="form.writeCardLimitType"
                        placeholder="请选择"
                    >
                        <el-option label="添加限制" value="1"></el-option>
                        <el-option label="解除限制" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="是否认证:"
                    required
                    prop="isAuth"
                    v-if="form.type === 53"
                >
                    <el-select v-model="form.isAuth" placeholder="请选择">
                        <el-option label="请选择" value=""></el-option>
                        <el-option label="否" value="1"></el-option>
                        <el-option label="是" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="uploadExcel"
                    >确认</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportTemplateExcel"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="dialogBox = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import { gridSetMealForImportCard } from "@/api/cardManagement/cardImport.js";
import {
    importList,
    getSetMealByCategory,
    accountList,
    importExcel,
} from "@/api/cardManagement/batchCard.js";
import { getActiveSeries } from "@/api/setMealManagment/setMealSeries.js"; // 套餐系列API（新UI）
import { messageBox, confirmBox } from "@/utils/common.js";
import SearchSelect from "@/components/SearchSelect";
import Utils from "@/utils/utils.js";
import { exportTemplate } from "@/api/statistics.js";
import resize from "@/mixins/resize.js";
import dictGroup from "@/mixins/dictGroup.js";
import { mapGetters } from "vuex";
import { getOperateList } from "@/api/cardManagement/cardBillDetail.js";
export default {
    name: "batchCard",
    mixins: [resize, dictGroup],
    data() {
        return {
            isCustomer: this.isGuangyao,
            dialogLoading: false,
            type: "",
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            dialogBox: false,
            agentLists: [],
            imeiAccountList: [],
            newMealsList: [],
            isGetMeal: true,
            // 省份映射
            provinceMap: {
                110000: "北京市",
                120000: "天津市",
                130000: "河北省",
                140000: "山西省",
                150000: "内蒙古自治区",
                210000: "辽宁省",
                220000: "吉林省",
                230000: "黑龙江省",
                310000: "上海市",
                320000: "江苏省",
                330000: "浙江省",
                340000: "安徽省",
                350000: "福建省",
                360000: "江西省",
                370000: "山东省",
                410000: "河南省",
                420000: "湖北省",
                430000: "湖南省",
                440000: "广东省",
                450000: "广西壮族自治区",
                460000: "海南省",
                500000: "重庆市",
                510000: "四川省",
                520000: "贵州省",
                530000: "云南省",
                540000: "西藏自治区",
                610000: "陕西省",
                620000: "甘肃省",
                630000: "青海省",
                640000: "宁夏回族自治区",
                650000: "新疆维吾尔自治区",
                710000: "台湾省",
                810000: "香港特别行政区",
                820000: "澳门特别行政区",
            },
            form: {
                type: 1,
                account: "",
                imeiIsDelete: "false",
                newMeals: "",
                seriesId: "", // 套餐系列ID（新UI）
                action: "1",
                quota: "",
                flowStop: "",
                daliangType: "1",
                expiredType: 1,
                toType: "",
                saleType: "",
                coType: "",
                productType: "",
                status: 0,
                iccids: "",
                setMealId: "",
                rechargeType: "",
                flowType: "2",
                province: null,
                operationType: "2",
                writeCardLimitType: "2",
                isAuth: "",
            },
            isRequired: true,
            placeholderText: "",
            manualInputTitle: "ICCID/短号",
            packageLists: [], //套餐
            seriesOptions: [], // 套餐系列选项（新UI）
            dicOperte: {
                one: "1",
                two: "1",
                four: "1",
                five: "1",
                six: "1",
                seven: "1",
                nine: "1",
                ten: "1",
                eleven: "1",
                twelve: "1",
                thirteen: "1",
                sixteen: "1",
                seventeen: "1",
                eighteen: "1",
                nineteen: "1",
                twenty: "1",
                twentyOne: "1",
                twentytwo: "1",
                twentythree: "1",
                twentyfour: "1",
                twentyfive: "1",
                twentysix: "1",
                thirty: "1",
                thirtyone: "1",
                thirtytwo: "1",
                thirtythree: "1",
                thirtyfour: "1",
                thirtyfive: "1",
                thirtysix: "1",
                thirtyseven: "1",
                fortysix: "1",
                fortyseven: "1",
                fiftytwo: "1",
                fiftythree: "1",
                fiftyeight: "1",
                fiftynine: "1",
            },
            rules: {
                account: [
                    {
                        required: true,
                        message: "请选择运营商",
                        trigger: "change",
                    },
                ],
                province: [
                    {
                        required: true,
                        message: "请选择归属省份",
                        trigger: "change",
                    },
                ],
                writeCardLimitType: [
                    {
                        required: true,
                        message: "请选择操作类型",
                        trigger: "change",
                    },
                ],
                isAuth: [
                    {
                        required: true,
                        message: "请选择是否认证",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    mounted() {
        this._importList();
        if (this.isCaptal == "1") {
            this.getOperateList();
        }

        // 预加载系列选项（新UI）
        if (this.SHOW_MEAL_SERIES == 1) {
            this.loadSeriesOptions();
        }

        // dicOperte.seven=='1'&&(currentRole==0 ||(currentRole==4&&agentTree==1))
        if (this.dicOperte.seven == "1" && this.currentRole == 0) {
            this.form.type = 1;
        } else if (
            this.dicOperte.seven == "1" &&
            this.currentRole == 4 &&
            this.agentTree == 1
        ) {
            this.form.type = 7;
            // 在新UI模式下，不自动加载套餐，等待用户选择系列
            if (this.SHOW_MEAL_SERIES != 1) {
                this._getSetMealByCategory();
            }
        }
    },
    methods: {
        getOperateList() {
            getOperateList({ group: "batch_import_menu" }).then((res) => {
                console.log(res);
                try {
                    res.forEach((item) => {
                        console.log(item.dictKey);
                        console.log(item.dictValue);
                        if (item.dictKey == "1") {
                            this.dicOperte.one = item.dictValue;
                        } else if (item.dictKey == "2") {
                            this.dicOperte.two = item.dictValue;
                        } else if (item.dictKey == "4") {
                            this.dicOperte.four = item.dictValue;
                        } else if (item.dictKey == "5") {
                            this.dicOperte.five = item.dictValue;
                        } else if (item.dictKey == "6") {
                            this.dicOperte.six = item.dictValue;
                        } else if (item.dictKey == "7") {
                            this.dicOperte.seven = item.dictValue;
                        } else if (item.dictKey == "9") {
                            this.dicOperte.nine = item.dictValue;
                        } else if (item.dictKey == "10") {
                            this.dicOperte.ten = item.dictValue;
                        } else if (item.dictKey == "11") {
                            this.dicOperte.eleven = item.dictValue;
                        } else if (item.dictKey == "12") {
                            this.dicOperte.twelve = item.dictValue;
                        } else if (item.dictKey == "13") {
                            this.dicOperte.thirteen = item.dictValue;
                        } else if (item.dictKey == "16") {
                            this.dicOperte.sixteen = item.dictValue;
                        } else if (item.dictKey == "17") {
                            this.dicOperte.seventeen = item.dictValue;
                        } else if (item.dictKey == "18") {
                            this.dicOperte.eighteen = item.dictValue;
                        } else if (item.dictKey == "19") {
                            this.dicOperte.nineteen = item.dictValue;
                        } else if (item.dictKey == "20") {
                            this.dicOperte.twenty = item.dictValue;
                        } else if (item.dictKey == "21") {
                            this.dicOperte.twentyOne = item.dictValue;
                        } else if (item.dictKey == "22") {
                            this.dicOperte.twentytwo = item.dictValue;
                        } else if (item.dictKey == "23") {
                            this.dicOperte.twentythree = item.dictValue;
                        } else if (item.dictKey == "24") {
                            this.dicOperte.twentyfour = item.dictValue;
                        } else if (item.dictKey == "25") {
                            this.dicOperte.twentyfive = item.dictValue;
                        } else if (item.dictKey == "26") {
                            this.dicOperte.twentysix = item.dictValue;
                        } else if (item.dictKey == "30") {
                            this.dicOperte.thirty = item.dictValue;
                        } else if (item.dictKey == "31") {
                            this.dicOperte.thirtyone = item.dictValue;
                        } else if (item.dictKey == "32") {
                            this.dicOperte.thirtytwo = item.dictValue;
                        } else if (item.dictKey == "33") {
                            this.dicOperte.thirtythree = item.dictValue;
                        } else if (item.dictKey == "34") {
                            this.dicOperte.thirtyfour = item.dictValue;
                        } else if (item.dictKey == "35") {
                            this.dicOperte.thirtyfive = item.dictValue;
                        } else if (item.dictKey == "36") {
                            this.dicOperte.thirtysix = item.dictValue;
                        } else if (item.dictKey == "37") {
                            this.dicOperte.thirtyseven = item.dictValue;
                        } else if (item.dictKey == "46") {
                            this.dicOperte.fortysix = item.dictValue;
                        } else if (item.dictKey == "47") {
                            this.dicOperte.fortyseven = item.dictValue;
                        } else if (item.dictKey == "52") {
                            this.dicOperte.fiftytwo = item.dictValue;
                        } else if (item.dictKey == "53") {
                            this.dicOperte.fiftythree = item.dictValue;
                        } else if (item.dictKey == "59") {
                            this.dicOperte.fiftynine = item.dictValue;
                        }
                    });
                } catch (error) {}

                // let arr =[]
                // arr=  res.filter(itemone=>{
                // 	return  itemone.dictValue=="1"
                // })
                // try {
                //  this.tabledata  =   this.tabledata.filter(item=>{
                // return 	arr.some(ele=>
                // {     console.log(ele.dictKey,item.switchType)
                // 	return  ele.dictKey===item.switchType.toString()})
                //    })
                //    console.log( this.tabledata)
                // } catch (error) {}
            });
        },
        secondClick(val) {
            setTimeout(() => {
                if (this.packageLists.length == 0 && val) {
                    this.$alert("请先选择运营商", "提示", {
                        confirmButtonText: "确定",
                    });
                    return;
                }
            }, 500);
        },
        changeGetMeal(val) {
            if (this.form.type != 25) {
                return;
            }
            this.form.setMealId = "";
            console.log(val);
            if (val) {
                gridSetMealForImportCard({ accountId: val }).then((res) => {
                    console.log(res);
                    this.packageLists = [];
                    if (res.data.length != 0) {
                        res.data.forEach((item) => {
                            if (item.type != 11) {
                                this.packageLists.push({
                                    label: item.name,
                                    value: item.id,
                                });
                            }
                        });
                    }
                });
            }
        },
        typeChange(val) {
            if (val === 10) {
                this.isRequired = false;
                this.placeholderText = "请输入ICCID/短号";
                this.manualInputTitle = "ICCID/短号";
            } else if (val === 59) {
                this.isRequired = false;
                this.placeholderText =
                    "每行一组：虚拟号与MAC用空格隔开（可与Excel二选一，优先文本）";
                this.manualInputTitle = "虚拟号与MAC";
            } else {
                this.isRequired = true;
                if (val === 25) {
                    this.placeholderText = "请输入ICCID/短号";
                    this.manualInputTitle = "ICCID/短号";
                } else if (val === 26) {
                    this.placeholderText =
                        "请输入ICCID和短号,每行一组，用英文逗号隔开";
                    this.manualInputTitle = "ICCID/短号";
                } else if (val == 37) {
                    this.placeholderText = "请输入申请编号";
                    this.manualInputTitle = "申请编号";
                } else if (val == 52) {
                    this.placeholderText = "请输入ICCID/短号";
                    this.manualInputTitle = "ICCID/短号";
                } else if (val == 53) {
                    this.placeholderText = "请输入ICCID/短号";
                    this.manualInputTitle = "ICCID/短号";
                } else {
                    this.placeholderText = "请输入ICCID/短号";
                    this.manualInputTitle = "ICCID/短号";
                }

                // else if(val===27){
                //     this.placeholderText = "请输入接入号和ICCID,每行一组，用英文逗号隔开"
                // }else if(val===28){
                //     this.placeholderText = "请输入原ICCID、接入号和新ICCID,每行一组，用英文逗号隔开"
                // }
            }
        },
        exportTemplateExcel() {
            let name;
            if (this.form.type == 1) {
                if (this.form.expiredType == 1) {
                    name = "expiredTimeD.xlsx";
                } else {
                    name = "expiredTimeT.xlsx";
                }
            } else if (this.form.type == 2) {
                // name ="recovery.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 30) {
                name = "importIccid.xls";
            } else if (this.form.type == 3) {
                // name ="stop.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 4) {
                // name ="threshold.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 5) {
                // name ="stop.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 6) {
                // name ="usurp.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 7) {
                // name ="usurp.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 9) {
                // name ="deviceBindCard.xlsx"
                name = "importIccid.xls";
            } else if (this.form.type == 10) {
                // name ="sim_recycle.xls"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 11) {
                // name ="cancel.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 12) {
                // name ="noRecharge.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 13) {
                name = "modify_flow.xls";
                // name = "importIccidOrShort.xls";
            } else if (this.form.type == 16) {
                name = "imei-base.xls";
            } else if (this.form.type == 17) {
                // name ="threshold.xlsx"
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 18) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 19) {
                // name = "threshold.xlsx";
                name = "importIccid.xls";
            } else if (this.form.type == 20) {
                // name = "threshold.xlsx";
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 21) {
                name = "remark_iccid.xls";
            } else if (this.form.type == 22) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 23) {
                if (this.form.status == 0) {
                    // name ="coverOrstop.xlsx"  //导出停机模板
                    name = "importIccidOrShort.xls"; //统一模板名称
                } else {
                    // name = "coverOrstop.xlsx";//导出复机模板
                    name = "importIccidOrShort.xls";
                }
            } else if (this.form.type == 24) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 25) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 26) {
                name = "importShortIccid.xls";
            } else if (this.form.type == 31) {
                name = "importIccid.xls";
            } else if (this.form.type == 32) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 33) {
                //需要确认
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 34) {
                //需要确认
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 35) {
                //导出模板待确认
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 36) {
                //导出模板待确认
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 37) {
                //导出模板待确认
                name = "importApplyNo.xls";
            } else if (this.form.type == 46) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 47) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 52) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 53) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 58) {
                name = "importIccidOrShort.xls";
            } else if (this.form.type == 59) {
                name = "importMac.xls";
            }

            exportTemplate({ name }).then((res) => {
                const filename = name;
                Utils.createDownload(res, filename);
            });
        },
        uploadExcel() {
            confirmBox(this, "确定导入吗？", "操作提示", () => {
                this.comfirmImport();
            });
        },
        comfirmImport() {
            // 如果是修改归属省份操作，需要验证省份选择并进行二次确认
            if (this.form.type === 35) {
                // 验证是否选择了归属省份
                if (!this.form.province) {
                    this.$alert("请选择归属省份", "提示", {
                        confirmButtonText: "确定",
                    });
                    return;
                }

                // 获取省份名称并进行二次确认
                const provinceName =
                    this.provinceMap[this.form.province] || this.form.province;
                this.$confirm(
                    `导入省份为：${provinceName}，请确认是否批量修改`,
                    "确认提示",
                    {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                    .then(() => {
                        // 确认后继续执行导入逻辑
                        this.executeImport();
                    })
                    .catch(() => {
                        // 取消操作，不做任何处理
                    });
                return;
            }

            // 非修改归属省份操作，直接执行导入逻辑
            this.executeImport();
        },
        /** MAC 导入：POST /card/batchAddMacSync.do，multipart 字段 pairs（文本）或 fileurl（Excel），优先 pairs */
        executeMacImport() {
            const pairsText = (this.form.iccids || "").trim();
            const file =
                this.$refs["file"] && this.$refs["file"].files
                    ? this.$refs["file"].files[0]
                    : null;
            const url = "/card/batchAddMacSync.do?";
            const donePairs = (res) => {
                if (res.system_result_key == "0") {
                    this.$alert(
                        res.system_result_message_key || "导入成功",
                        "提示",
                        {
                            confirmButtonText: "确定",
                        }
                    ).then(() => {
                        this.dialogBox = false;
                        this._importList();
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            };
            const doneFile = (res) => {
                if (res.system_result_key == "0") {
                    this.$alert("导入成功，请到导入记录中下载", "提示", {
                        confirmButtonText: "确定",
                    }).then(() => {
                        this.dialogBox = false;
                        this._importList();
                        this.$router.push("/tob/i_import_list");
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            };
            if (pairsText) {
                const params = new FormData();
                params.append("pairs", pairsText);
                importExcel(url, params).then(donePairs);
                return;
            }
            if (file) {
                const fileName = file.name;
                const index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                const ck = Utils.checkFile(file);
                if (ck === 1) {
                    messageBox(this, "上传文件不能超过20M");
                    return;
                }
                if (ck === 2) {
                    messageBox(this, "上传文件名称长度不能超过36个字符");
                    return;
                }
                const params = new FormData();
                params.append("fileurl", file);
                importExcel(url, params).then(doneFile);
                return;
            }
            messageBox(
                this,
                "请选择文件或输入 ICCID/短号与 MAC（每行一组，空格隔开）"
            );
        },
        executeImport() {
            if (this.form.type === 59) {
                this.executeMacImport();
                return;
            }
            let file = this.$refs["file"].files[0];
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                } else if (!!Utils.checkFile(file)) {
                    if (Utils.checkFile(file) == 1) {
                        messageBox(this, "上传文件不能超过20M");
                        return;
                    } else if (Utils.checkFile(file) == 2) {
                        messageBox(this, "上传文件名称长度不能超过36个字符");
                        return;
                    }
                } else {
                    let params = new FormData();
                    params.append("fileurl", file);
                    params.append("type", this.form.type);
                    params.append("fromRange", false);
                    let url;
                    if (this.form.type == 1) {
                        params.append("expiredType", this.form.expiredType);
                        if (this.form.expiredType == 1) {
                            url = "card/import/expiredTimeSync.do?";
                        } else {
                            url = "card/import/expiredTimeSync.do?";
                            params.append("type", 2);
                        }
                    } else if (this.form.type == 2) {
                        url = "card/import/recoveryCardSync.do?";
                    } else if (this.form.type == 3) {
                        url = "card/import/stopCardSync.do?";
                    } else if (this.form.type == 4) {
                        params.append("action", this.form.action);
                        params.append("quota", this.form.quota);
                        params.append("daliangType", this.form.daliangType);
                        url = "card/import/thresholdSync.do?";
                    } else if (this.form.type == 5) {
                        url = "card/import/deleteCardSync.do?";
                    } else if (this.form.type == 6) {
                        url = "card/import/usurpCardSync.do?";
                    } else if (this.form.type == 7) {
                        params.append("newMealId", this.form.newMeals);
                        url = "card/import/changeMealSync.do?";
                    } else if (this.form.type == 9) {
                        url = "card/import/deviceBindCardSync.do?";
                    } else if (this.form.type == 10) {
                        url =
                            "record/cardRecycleRecord/cardRecycleByExcelSync.do?";
                    } else if (this.form.type == 11) {
                        url = "card/import/cancelSync.do?";
                    } else if (this.form.type == 12) {
                        url = "card/import/noRechargeSync.do?";
                    } else if (this.form.type == 13) {
                        url =
                            "record/updateFlowRecord/updateFlowByExcelSync.do?";
                    } else if (this.form.type == 16) {
                        params.append("accountId", this.form.account);
                        params.append("isDelete", this.form.imeiIsDelete);
                        url = "card/imeibase/import4imeiSync.do?";
                    } else if (this.form.type == 17) {
                        params.append("toType", this.form.toType);
                        params.append("saleType", this.form.saleType);
                        params.append("coType", this.form.coType);
                        params.append("productType", this.form.productType);
                        url = "card/import/changeTypeSync.do?";
                    } else if (this.form.type == 18) {
                        params.append("expireTime", this.form.expireTime);
                        url = "card/import/setExpireSync.do?";
                    } else if (this.form.type == 19) {
                        params.append("flowStop", this.form.flowStop);
                        url = "chargeGroup/importCardStopSync.do?";
                    } else if (this.form.type == 20) {
                        url = "card/import/cancelDxDisconnectedAsync.do?";
                    } else if (this.form.type == 21) {
                        url = "cardRemark/updateB.do?";
                    } else if (this.form.type == 22) {
                        url = "/card/batchRejectClear.do?";
                    } else if (this.form.type == 23) {
                        params.append("status", this.form.status);
                        url = "card/coverOrstop.do?";
                    } else if (this.form.type == 24) {
                        url = "card/batchStopBind.do?";
                    } else if (this.form.type == 25) {
                        if (this.form.account == "") {
                            this.$alert("请选择运营商", "提示", {
                                confirmButtonText: "确定",
                            });
                            return;
                        }
                        // console.log(this.form.setMealId == "",this.form.setMealId)
                        // if (this.form.setMealId == "") {
                        //   this.$alert("请选择套餐", "提示", {
                        //     confirmButtonText: "确定",
                        //   });
                        //   return;
                        // }
                        params.append("accountId", this.form.account);
                        params.append("setMealId", this.form.setMealId);
                        url = "/card/accountEditByExcelSync.do?";
                    } else if (this.form.type == 26) {
                        url = "/card/shortIccidEditByExcelSync.do?";
                    } else if (this.form.type == 30) {
                        url = "/card/batchForceActive.do?";
                    } else if (this.form.type == 31) {
                        console.log(this.form.silentExpireTime);
                        if (this.form.silentExpireTime == undefined) {
                            this.$alert("请选择沉默期时间", "提示", {
                                confirmButtonText: "确定",
                            });
                            return;
                        }
                        params.append(
                            "silentExpireTime",
                            this.form.silentExpireTime
                        );
                        url = "/card/batchSetSilentTime.do?";
                    } else if (this.form.type == 32) {
                        if (this.form.rechargeType == "") {
                            this.$alert("请选择充值类型", "提示", {
                                confirmButtonText: "确定",
                            });
                            return;
                        }
                        params.append("rechargeType", this.form.rechargeType);
                        url = "/card/reChargeTypeEditByExcelSync.do?";
                    } else if (this.form.type == 33) {
                        url = "/card/advanceLifeByExcelSync.do?";
                    } else if (this.form.type == 34) {
                        params.append("flowType", this.form.flowType);
                        url = "/card/changeFlowTypeSync.do?";
                    } else if (this.form.type == 35) {
                        //导入excel
                        params.append("province", this.form.province);
                        url = "/card/changeProvinceSync.do?";
                    } else if (this.form.type == 36) {
                        params.append("switchPriority", "10");
                        url = "/card/changeSwitchPrioritySync.do?";
                    } else if (this.form.type == 37) {
                        params.append("operationType", this.form.operationType);
                        url = "/card/batchUpdateCardSync.do?";
                    } else if (this.form.type == 46) {
                        url = "/card/batchImportTempIccidSync.do?";
                    } else if (this.form.type == 47) {
                        url = "/card/batchDeleteTempIccidSync.do?";
                    } else if (this.form.type == 52) {
                        params.append("type", this.form.writeCardLimitType);
                        url = "/card/batchOperateWriteCardLimit.do?";
                    } else if (this.form.type == 53) {
                        if (this.form.isAuth == "") {
                            this.$alert("请选择是否认证", "提示", {
                                confirmButtonText: "确定",
                            });
                            return;
                        }
                        params.append("isAuth", this.form.isAuth);
                        url = "/card/batchUpdateAuthSync.do?";
                    } else if (this.form.type == 58) {
                        url = "card/batchRefreshFlow.do?";
                    }

                    importExcel(url, params).then((res) => {
                        if (res.system_result_key == "0") {
                            // 判断是否为修改流量类型为本省流量的情况
                            let alertMessage = "导入成功，请到导入记录中下载";
                            if (
                                this.form.type === 34 &&
                                this.form.flowType === "1"
                            ) {
                                alertMessage =
                                    "导入成功，已修改为本省流量，请前往修改省份";
                            }

                            this.$alert(alertMessage, "提示", {
                                confirmButtonText: "确定",
                            }).then(() => {
                                this.dialogBox = false;
                                // 刷新列表数据
                                this._importList();
                                this.$router.push("/tob/i_import_list");
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.system_result_message_key,
                                type: "error",
                            });
                        }
                    });
                }
            } else if (!!this.form.iccids.trim()) {
                // if(!Utils.checkICCID(this.form.iccids)){
                //   messageBox(this,'iccid只能包含数字和字母')
                //   return
                // }
                let params = new FormData();
                params.append("type", this.form.type);
                params.append("fromRange", false);
                let url;
                if (this.form.type == 7) {
                    params.append("iccids", this.form.iccids);
                    params.append("newMealId", this.form.newMeals);
                    url = "card/import/changeMealSync.do?";
                }
                if (this.form.type == 10) {
                    params.append("iccids", this.form.iccids);
                    url = "record/cardRecycleRecord/cardRecycleByExcelSync.do?";
                }
                if (this.form.type == 25) {
                    if (this.form.account == "") {
                        this.$alert("请选择运营商", "提示", {
                            confirmButtonText: "确定",
                        });
                        return;
                    }
                    params.append("iccids", this.form.iccids);
                    params.append("accountId", this.form.account);
                    params.append("setMealId", this.form.setMealId);
                    url = "/card/accountEditByExcelSync.do?";
                }
                if (this.form.type == 26) {
                    params.append("iccids", this.form.iccids);
                    url = "/card/shortIccidEditByExcelSync.do?";
                }
                if (this.form.type == 32) {
                    if (this.form.rechargeType == "") {
                        this.$alert("请选择充值类型", "提示", {
                            confirmButtonText: "确定",
                        });
                        return;
                    }
                    params.append("rechargeType", this.form.rechargeType);
                    params.append("iccids", this.form.iccids);
                    url = "/card/reChargeTypeEditByExcelSync.do?";
                }
                if (this.form.type == 33) {
                    params.append("iccids", this.form.iccids);
                    url = "/card/advanceLifeByExcelSync.do?";
                }
                if (this.form.type == 34) {
                    params.append("flowType", this.form.flowType);
                    params.append("iccids", this.form.iccids);
                    url = "/card/changeFlowTypeSync.do?";
                } else if (this.form.type == 35) {
                    params.append("province", this.form.province);
                    params.append("iccids", this.form.iccids);
                    url = "/card/changeProvinceSync.do?";
                } else if (this.form.type == 36) {
                    params.append("switchPriority", "10");
                    params.append("iccids", this.form.iccids);
                    url = "/card/changeSwitchPrioritySync.do?";
                } else if (this.form.type == 37) {
                    params.append("applyNos", this.form.iccids);
                    params.append("operationType", this.form.operationType);
                    url = "/card/batchUpdateCardSync.do?";
                }
                if (this.form.type == 46) {
                    params.append("iccids", this.form.iccids);
                    url = "/card/batchImportTempIccidSync.do?";
                } else if (this.form.type == 47) {
                    params.append("iccids", this.form.iccids);
                    url = "/card/batchDeleteTempIccidSync.do?";
                } else if (this.form.type == 52) {
                    params.append("iccids", this.form.iccids);
                    params.append("type", this.form.writeCardLimitType);
                    url = "/card/batchOperateWriteCardLimit.do?";
                } else if (this.form.type == 53) {
                    if (this.form.isAuth == "") {
                        this.$alert("请选择是否认证", "提示", {
                            confirmButtonText: "确定",
                        });
                        return;
                    }
                    params.append("iccids", this.form.iccids);
                    params.append("isAuth", this.form.isAuth);
                    url = "/card/batchUpdateAuthSync.do?";
                } else if (this.form.type == 58) {
                    params.append("iccids", this.form.iccids);
                    url = "card/batchRefreshFlow.do?";
                }

                importExcel(url, params).then((res) => {
                    if (res.system_result_key == "0") {
                        // 判断是否为修改流量类型为本省流量的情况
                        let alertMessage = "导入成功";
                        if (
                            this.form.type === 34 &&
                            this.form.flowType === "1"
                        ) {
                            alertMessage = "已修改为本省流量，请前往修改省份";
                        }

                        this.$alert(alertMessage, "提示", {
                            confirmButtonText: "确定",
                        }).then(() => {
                            this.dialogBox = false;
                            // 刷新列表数据
                            this._importList();
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key,
                            type: "error",
                        });
                    }
                });
            } else {
                if (this.form.type == 10) {
                    messageBox(this, "请选择文件或输入iccid");
                } else {
                    messageBox(this, "请选择文件");
                }

                return;
            }
        },
        loadFail(isId) {
            this.$router.push({
                path: "/cardManagement/batchCardFailList",
                query: { isId },
            });
        },

        searchTable() {
            this.currentPage = 1;
            this._importList();
        },
        importRecord() {
            this.dialogBox = true;
            // 使用 $nextTick 确保对话框渲染完成后再访问 $refs
            this.$nextTick(() => {
                if (this.$refs["file"]) {
                    this.$refs["file"].value = "";
                }
            });
            this.form.iccids = "";
            this.form.province = "";
            this.form.writeCardLimitType = "2";
            this.form.isAuth = "";
            // 重置系列选择（新UI）
            this.form.seriesId = "";

            // 当打开对话框时加载系列选项（新UI）
            if (this.SHOW_MEAL_SERIES == 1) {
                this.loadSeriesOptions();
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this._importList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this._importList();
        },
        _accountList() {
            if (this.form.type != 16 && this.form.type != 25) {
                return;
            }
            this.dialogLoading = true;
            var params = {};
            params.type = 7;
            params.action = this.form.action;
            params.daliangType = this.form.daliangType;
            params.expiredType = this.form.expiredType;
            params.newMeals = this.form.newMeals;
            accountList(params).then((res) => {
                this.imeiAccountList = res.map((item, i) => {
                    if (i == 0) {
                        // this.form.account = item.id
                    }
                    return {
                        label: item.accountName,
                        value: item.id,
                    };
                });
                this.dialogLoading = false;
            });
        },
        // 加载套餐系列数据（新UI）
        async loadSeriesOptions() {
            try {
                console.log("开始加载系列数据...");
                const res = await getActiveSeries();
                console.log("系列数据完整响应:", res);

                // 使用项目标准响应格式处理
                if (Array.isArray(res)) {
                    // Axios响应拦截器已经提取了data字段，直接返回数组格式
                    this.seriesOptions = res;
                    console.log("加载的系列选项:", this.seriesOptions);
                } else {
                    console.error("系列数据返回格式异常:", res);
                    this.seriesOptions = [];
                }

                if (this.seriesOptions.length === 0) {
                    console.warn(
                        "系列数据为空，请检查数据库中是否有启用状态的系列数据"
                    );
                }
            } catch (e) {
                console.error("加载系列选项失败:", e);
                console.error("错误详情:", e.response || e.message);
                this.seriesOptions = [];
            }
        },

        // 导入类型变化处理
        handleTypeChange() {
            console.log("导入类型变化为变更套餐");
            // 在新UI模式下，只有选择了系列才加载套餐
            if (this.SHOW_MEAL_SERIES == 1) {
                if (this.form.seriesId) {
                    this._getSetMealByCategory(this.form.seriesId);
                } else {
                    // 清空套餐列表，等待用户选择系列
                    this.newMealsList = [];
                    this.form.newMeals = "";
                }
            } else {
                // 旧UI模式，直接加载所有套餐
                this._getSetMealByCategory();
            }
        },

        // 系列选择变化处理（新UI）
        handleSeriesChange(seriesId) {
            console.log("===== 系列选择变化 =====");
            console.log("新选择的系列ID:", seriesId, "类型:", typeof seriesId);
            console.log("当前isGetMeal状态:", this.isGetMeal);
            console.log("当前系列选项:", this.seriesOptions);

            this.form.newMeals = ""; // 清空已选套餐
            if (seriesId) {
                console.log("加载系列下的套餐:", seriesId);
                this._getSetMealByCategory(seriesId);
            } else {
                console.log("清空系列筛选，不显示套餐");
                // 在新UI模式下，如果没有选择系列，直接清空套餐列表
                if (this.SHOW_MEAL_SERIES == 1) {
                    this.newMealsList = [];
                    this.form.newMeals = "";
                } else {
                    this._getSetMealByCategory();
                }
            }
        },

        _getSetMealByCategory(filterSeriesId = null) {
            if (this.form.type != 7) {
                return;
            }
            if (!this.isGetMeal) {
                return;
            }

            // 新UI逻辑：如果没有选择系列，则不加载套餐列表
            if (this.SHOW_MEAL_SERIES == 1 && !filterSeriesId) {
                console.log("新UI模式下未选择系列，清空套餐列表");
                this.newMealsList = [];
                this.form.newMeals = "";
                return;
            }

            this.dialogLoading = true;
            this.isGetMeal = false;
            var params = {};
            params.type = 7;
            params.action = this.form.action;
            params.daliangType = this.form.daliangType;
            params.expiredType = this.form.expiredType;

            // 如果有系列筛选，添加系列ID参数（新UI）
            if (filterSeriesId && this.SHOW_MEAL_SERIES == 1) {
                params.seriesId = filterSeriesId;
                console.log("添加系列筛选参数:", filterSeriesId);
            }

            console.log("发送API请求参数:", params);
            getSetMealByCategory(params)
                .then((res) => {
                    console.log("套餐API返回结果:", res);
                    let meal = [];
                    res.forEach((item, i) => {
                        if (item.type === 1) {
                            this.dialogLoading = false;
                            return;
                        } else {
                            let _label = item.name;
                            let accountName = item.accountName;
                            meal.push({
                                label: _label + "(" + accountName + ")",
                                value: item.id,
                            });
                            // 新UI逻辑：不自动选择第一个套餐，让用户手动选择
                            if (i == 0 && this.SHOW_MEAL_SERIES != 1) {
                                this.form.newMeals = item.id;
                            }
                        }
                    });
                    console.log("处理后的套餐列表:", meal);
                    this.newMealsList = meal;
                    this.dialogLoading = false;
                    // 重置标志位，允许后续调用
                    this.isGetMeal = true;
                })
                .catch((error) => {
                    console.error("获取套餐列表失败:", error);
                    this.dialogLoading = false;
                    // 即使失败也要重置标志位，允许重试
                    this.isGetMeal = true;
                    this.$message.error("获取套餐列表失败，请重试");
                });
        },
        _importList() {
            let params = {};
            params.pageSize = this.pageSize;
            params.pageNo = this.currentPage;
            params.type = this.type;
            importList(params).then((res) => {
                this.tableData = res.rows;
                this.pageSize = res.pageSize;
                this.currentPage = res.pageNo;
                this.total = res.total;
            });
        },
    },
    components: {
        SearchSelect,
    },
    computed: {
        ...mapGetters([
            "isCaptal",
            "currentRole",
            "agentTree",
            "isGuangyao",
            "showBatchUpdateCard",
            "SHOW_MEAL_SERIES",
            "TEMP_CARD",
            "REAL_NAME_LIMIT",
        ]),
    },
};
</script>
